import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getWeeklyRanking } from '../../api/ranking';
import './styles/WeeklyRanking.scss';

const WeeklyRanking = () => {
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    getWeeklyRanking(10)
      .then((res) => setRanking(res.data))
      .catch(() => {});
  }, []);

  if (ranking.length === 0) return null;

  return (
    <section className="weekly-ranking">
      <h2>今注目の人</h2>
      <ul className="weekly-ranking__list">
        {ranking.map((user, i) => (
          <li key={user.userId} className="weekly-ranking__item">
            <span className="weekly-ranking__rank">{i + 1}</span>
            <img
              src={user.profileImageUrl || '/images/profileImage.png'}
              alt={user.name}
              className="weekly-ranking__avatar"
              loading="lazy"
              decoding="async"
              width={48}
              height={48}
            />
            <div className="weekly-ranking__info">
              <p className="weekly-ranking__name">{user.name}</p>
              <p className="weekly-ranking__category">{user.category}</p>
            </div>
            <Link to={`/preview/${user.userId}`} className="weekly-ranking__link">
              シートを見る
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default WeeklyRanking;
